import { render, staticRenderFns } from "./_6.vue?vue&type=template&id=704846b7&scoped=true&"
import script from "./_6.vue?vue&type=script&lang=js&"
export * from "./_6.vue?vue&type=script&lang=js&"
import style0 from "./_6.vue?vue&type=style&index=0&id=704846b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704846b7",
  null
  
)

export default component.exports